import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  footer?: React.ReactNode;
  onClick?: () => void;
  variant?: 'default' | 'outline' | 'elevated' | 'premium';
}
export function Card({
  children,
  className = '',
  title,
  footer,
  onClick,
  variant = 'default'
}: CardProps) {
  const variants = {
    default: 'bg-white border border-slate-200 shadow-soft hover:shadow-soft-lg hover:border-accent-600',
    outline: 'bg-transparent border border-slate-200 hover:border-accent-600 hover:bg-slate-50',
    elevated: 'bg-white shadow-elevated border-t border-slate-100',
    premium: 'bg-white border border-gold-200 shadow-soft hover:shadow-soft-lg hover:border-gold-500 ring-1 ring-gold-100/50'
  };
  return <div className={`
        relative overflow-hidden rounded-xl transition-all duration-300 group
        ${variants[variant]}
        ${onClick ? 'cursor-pointer transform hover:-translate-y-1' : ''}
        ${className}
      `} onClick={onClick} data-id="element-51">
      {title && <div className="px-5 sm:px-7 py-5 sm:py-6 border-b border-slate-100" data-id="element-52">
          <h3 className="font-semibold text-lg sm:text-xl text-primary-900 tracking-tight group-hover:text-accent-600 transition-colors duration-300" data-id="element-53">
            {title}
          </h3>
        </div>}

      <div className="p-5 sm:p-7" data-id="element-54">{children}</div>

      {footer && <div className="px-5 sm:px-7 py-4 sm:py-5 bg-slate-50 border-t border-slate-100 rounded-b-xl" data-id="element-55">
          {footer}
        </div>}
    </div>;
}